import { actionItemsService } from "../../services/api/action-items.endpoints";

async function createNewTasks(oauthTokenHeader: string, data: any) {
  try {
    const response = await actionItemsService.createActionItem(
      oauthTokenHeader,
      data,
    );
    // Ensure response exists and check for both 200 and 201
    if (!response || !response.status) {
      return { reason: "Failed to create new task." };
    }

    if (response.status === 200) {
      return response;
    } else if (response.status === 201) {
      return response;
    }
  } catch (e: any) {
    throw e;
  }
}

const GenericEndPointsLogic = {
  createNewTasks,
};

export default GenericEndPointsLogic;
